export var AccessibleType = 'public';
export var LocationType = 'poi_location';
export var ConditionType = { number: 'number', select: 'select' };
